<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Edit Supplier Materials

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px">


            <form class="form" novalidate="" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Specification Details </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Specification Details"
                                         pattern="^[\sa-zA-Z0-9,._''\-?]*$"
                                         maxlength="100" />
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Min Ord Qty</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Min Ord Qty"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Max Ord Qty</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Max Ord Qty"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Lead Time(days)</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Lead Time(days)"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Has Rate Contract</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Has Rate Contract"
                                         pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          

                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>


      </div>
      
    </div>
  </div>
</div>
